import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";
import { useFormikContext } from "formik";
import { map } from "lodash";
import { useCallback, useMemo } from "react";
import { CreateEnrichmentData } from "../../../types/enrichment";

export function Rules() {
  const formik = useFormikContext<CreateEnrichmentData>();

  const rules = useMemo(() => {
    return [
      { label: "Substituir valores existentes", value: "update" },
      { label: "Completar campos em branco", value: "complete" },
    ];
  }, []);

  const keys = useMemo(() => {
    return [
      { label: "Documento", value: "document" },
      { label: "Celular", value: "cellphone" },
    ];
  }, []);

  const handleChange = useCallback(
    (key: string, value: string) => {
      formik.setFieldValue(key, value);
    },
    [formik]
  );

  return (
    <>
      <Typography color="primary">Regras</Typography>
      <RadioGroup
        defaultValue="update"
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        onChange={(_, value) => handleChange("rule", value)}
      >
        {map(rules, (rule, index) => (
          <FormControlLabel
            key={index.toString()}
            value={rule.value}
            control={<Radio />}
            label={rule.label}
          />
        ))}
      </RadioGroup>

      <Typography color="primary">Chave de enriquecimento</Typography>
      <RadioGroup
        defaultValue="document"
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        onChange={(_, value) => handleChange("key", value)}
      >
        {map(keys, (key, index) => (
          <FormControlLabel
            key={index.toString()}
            value={key.value}
            control={<Radio />}
            label={key.label}
          />
        ))}
      </RadioGroup>
    </>
  );
}
